/*
订单确认页面 
 */
 <template>
  <div class="orders">
     <z-affix-top-btn :scrollOffset="700" v-if="ordersDetail.stateId !== 600 && ordersDetail.stateId !== 400">
      <Row type="flex" justify="center" align="middle">
        <Col span="12" class="text-left">
          <router-link to="/project-list">
            <Button
              type="text"
            >
              <span style="float:left;">进入我的项目</span>
              <i class="iconfont icon-xiayige" style="margin-top: -2px;margin-left: 5px;float: left;"></i>
            </Button>
          </router-link>
        </Col>
        <Col span="12" class="text-right">
          <Row
            :gutter="20"
            type="flex"
            justify="end"
            align="middle"
          >       
            <!-- <Col span="6" v-if="ordersDetail && ordersDetail.orderStageList[0] && ordersDetail.orderStageList[0].paymentState <= 100 && ordersDetail.stateId !== 600 && ordersDetail.stateId < 200">
              <Button
                @click="cencelOrderHandle"
                long
                size="large"
              >取消订单</Button>
            </Col> -->
            <Col span="6" v-if="submit_btn_txt">
              <Button
                @click="submitBtnHandle(submit_btn_txt.type)"
                long
                type="primary"
                class="red-btn"
                size="large"
              >{{submit_btn_txt.txt}}</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </z-affix-top-btn>

    <div class="orders-com">
      <!-- 取消订单的遮罩 -->
      <div class="cancel-dialog" v-if="ordersDetail.stateId === 600"></div> 
      <div class="order-detail" v-if="ordersDetail">
        <z-steps-many
          v-if="ordersDetail.guideList && ordersDetail.guideList.length > 1 && ordersDetail.stateId !== 600"
          :step="guideListActive(ordersDetail.guideList)"
          :orderSteps="ordersDetail.guideList"
          :ordersDetail="ordersDetail"
        >
          <div class="action-all" v-if="totalStatus(ordersDetail.detailStatus)">
            <div class="stateText">
              <i class="iconfont" :class="totalStatus(ordersDetail.detailStatus).icon"></i>
              <span>{{ordersDetail.describeResponseVO.title}}</span>  
            </div> 
            <div class="subStateText" v-if="ordersDetail.detailStatus !== 100">{{ordersDetail.describeResponseVO.content}}</div>
            <div class="subStateText" v-else>{{countdown}}</div>
            <Row class="stateBtn" type="flex" justify="start" align="middle" :gutter="12">
              <Col>
                您可以
              </Col>

              <Col span="2" v-if="(totalStatus(ordersDetail.detailStatus).btn_main && this.ordersDetail.payInfomation && this.ordersDetail.payInfomation.buttonAction === 1 && ordersDetail.stateId !== 50 || (ordersDetail.realAmount < ordersDetail.receiveAmount)) && totalStatus(ordersDetail.detailStatus).status !== 5">
                <Button @click="totalMainActionHandle(totalStatus(ordersDetail.detailStatus).status)" long type="primary" class="red-btn">{{totalStatus(ordersDetail.detailStatus).btn_main}}</Button>
              </Col>
              <Col span="2" v-if="totalStatus(ordersDetail.detailStatus).btn_main && totalStatus(ordersDetail.detailStatus).status === 5">
                <Button @click="totalMainActionHandle(totalStatus(ordersDetail.detailStatus).status)" long type="primary" class="red-btn">{{totalStatus(ordersDetail.detailStatus).btn_main}}</Button>
              </Col>

              <Col v-if="totalStatus(ordersDetail.detailStatus).btn_sub">
                <Button @click="totalSubActionHandle(totalStatus(ordersDetail.detailStatus).status)" class="line-white-btn" long>{{totalStatus(ordersDetail.detailStatus).btn_sub}}</Button>
              </Col>

              <Col>或</Col>

              <Col v-if="totalStatus(ordersDetail.detailStatus).text_btn">
                <span @click="totalActionsHandle(item.status)" v-for="item in totalStatus(ordersDetail.detailStatus).text_btn">{{item.title}}</span>
              </Col>
            </Row>
          </div> 
        </z-steps-many>
        <div v-if="ordersDetail.stateId === 600" class="closeOrder">
          <span>订单关闭</span>
          <p v-if="ordersDetail.closeType && ordersDetail.closeType === 1">订单取消</p> 
          <p v-if="ordersDetail.closeType && ordersDetail.closeType === 2">订单退款</p> 
        </div>

        <layout
          :title="'订单号：' + ordersDetail.code"
          :subtitle="ordersDetail.createTime"
          :projectName="ordersDetail.projectName"
          @rightSubmit="cencelOrderHandle"
          
        >
        <!-- :rightBtn="ordersDetail.orderStageList[0] && ordersDetail.orderStageList[0].paymentState <= 100 && ordersDetail.stateId !== 600 && ordersDetail.stateId < 200 ? '取消订单' : ''" -->
          <Row>
            <Col span="12">
              <p class="order-title">合同信息</p>
              <div class="order-info">
                <p>
                  <span>甲方：{{ordersDetail.authName}}</span>
                </p>
                <!-- 江苏斑斓家居科技有限公司 -->
                <p>乙方：{{ordersDetail.contractPartyB}}</p>
                <p v-if="getSignedData">
                  <Button
                    class="download"
                    size="small"
                    :loading="BUTTON_NAME['ORDER_DOWN_LOAD']"
                    v-if="permissionFuc('order:contract:download')"
                    @click="contractDownLoad(getSignedData.contractFile, getSignedData.type)"
                  >{{getSignedData.type === 2 ? (getSignedData.contractFile ? '查看合同': '合同生成中...') : (getSignedData.contractFile ? '查看合同': '合同预览')}}</Button>
                  <a
                    :href="ossPrefix + getSignedData.contractFile.key"
                    target="_blank"
                    v-if="getSignedData.contractFile"
                  >
                    <Button
                      class="download"
                      size="small"
                      v-if="getSignedData.type === 1 && getSignedData.contractFile"
                    下载合同</Button>
                  </a>
                  <Tag
                    v-if="getSignedData.type === 2"
                    class="Tag Tag-big Tag-no-border tag-color-green"
                    color="green"
                  >已确认</Tag>
                  <Tag v-else class="Tag Tag-big Tag-no-border" color="red">未确认</Tag>
                </p>
              </div>
              <p class="order-title" v-if="ordersDetail.userDeliveryAddress">收货地址</p>
              <div class="order-info" v-if="ordersDetail.userDeliveryAddress">
                <p>
                  <span>{{ordersDetail.userDeliveryAddress.userName}}</span>
                  <span class="first-scond">{{ordersDetail.userDeliveryAddress.userMobile}}</span>
                </p>
                <p>{{ordersDetail.userDeliveryAddress.detailAddress}}</p>
              </div>
              <!-- <p class="order-title">
                付款阶段
                <phase :steps="ordersDetail.orderStageList" title="支付阶段" icon="icon-doubt"></phase>
              </p>-->
              <div class="order-info" v-if="ordersDetail.orderStageList">
                <!-- <p v-for="(item, index) in ordersDetail.orderStageList">
                  <span v-if="item.id">
                    {{item.stgTitle}}（总价{{item.paymentPercent}}%）：
                    <span
                      class="price"
                    >{{item.paymentAmount | currency('¥', '2')}}</span>
                  </span>
                </p>-->
                <p v-if="ordersDetail.comment">订单备注：{{ordersDetail.comment}}</p>
              </div>
            </Col>
            <Col span="12">
              <price-show
                v-if="ordersDetail.calculatePriceResponseVO"
                :promotions="ordersDetail.calculatePriceResponseVO"
                :service="ordersDetail.serviceCostRecord"
              ></price-show>
              <Row
                v-if="ordersDetail.stateId !== 400 && ordersDetail.stateId !== 600"
                style="margin-top:40px;"
                :gutter="20"
                type="flex"
                justify="end"
                align="middle"
              >
                <Col span="9" v-if="submit_btn_txt">
                  <Button
                    @click="submitBtnHandle(submit_btn_txt.type)"
                    long
                    type="primary"
                    class="red-btn"
                    size="large"
                  >{{submit_btn_txt.txt}}</Button>
                  <p style="margin-top:10px;font-size:13px"  v-if="submit_btn_txt.type === 2">{{countdown}}</p>
                </Col>
              </Row>
              <Row
                v-if="ordersDetail.stateId === 400 && ordersDetail.stateId !== 600"
                style="margin-top:40px;"
                :gutter="20"
                type="flex"
                justify="end"
                align="middle"
              >
                <Col span="9">
                  <Button long disabled>订单已完成</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </layout>

        <!-- 产品修改清单 -->
        <!-- <layout
          title="产品修改清单"
          :padding="false"
          :exportData="true"
          :toggleTap="ordersDetail.orderModifyList && ordersDetail.orderModifyList.length > 1 ? true :false"
          @toggleHandle="toggleHandle"
          @exportDataHandle="exportDataHandle"
          :exprotModify="exprotModify"
          v-if="ordersDetail && orderModifyList && orderModifyList.length >0"
          :rightBtnText="rightBtnText"
        >
          <modifys
            @reloadDetails="getOrdersDetail('upReload')"
            :lists="orderModifyList" 
            :allLists="ordersDetail.orderModifyList || []"
          ></modifys>
        </layout> -->

        <!-- 付款阶段 -->
        <layout
          title="付款阶段"
          :padding="false"
          v-if="ordersDetail && ordersDetail.orderStageList && ordersDetail.orderStageList.length > 0"
        >
          <payment-stage
            :orderStageList="ordersDetail.orderStageList"
            :ordersDetail="ordersDetail"
            :additionList="ordersDetail.additionList"
            @submitBtnHandleStage="submitBtnHandleStage"
          ></payment-stage>
        </layout>

        <!-- 支付记录 -->
        <layout title="支付记录" :padding="false">
          <payment-record
            :orderReceiveList="ordersDetail.orderReceiveList"
            :ordersDetail="ordersDetail"
          ></payment-record>
        </layout>

        <!-- 生产事项 -->
        <div id="#setOffProduct">
        <layout title="生产事项">
            <div class="product-todos" v-if="ordersDetail">
              <layout
                v-if="productTodosLab === '0'"
                class="product-laylot"
                :rightBtn="'导出面料色板'"
                :rightBtnMain="'查看全部'"
                id="meauTarget"
                @rightSubmit="exportExcel"
                @rightMainSubmit="rightMainSubmit"
                :padding="false"
              ></layout>
              <layout
                v-if="productTodosLab === '1'"
                class="product-laylot"
                :padding="false"
                :exportData="true"
                :toggleTap="ordersDetail.orderModifyList && ordersDetail.orderModifyList.length > 1 ? true :false"
                @toggleHandle="toggleHandle"
                @exportDataHandle="exportDataHandle"
                :exprotModify="exprotModify"
                :rightBtnText="rightBtnText"
              ></layout>

              <Tabs :value="productTodosLab" @on-click="onTabChange" :animated="false" class="detail-tab-style">
                
                <div class="upSign upSign1" v-if="orderDiaryNum(ordersDetail.orderDiaryDescResponseVOList) > 0">{{orderDiaryNum(ordersDetail.orderDiaryDescResponseVOList)}}</div>
                <div class="upSign upSign2" v-if="getShowWaitConfirm(ordersDetail.orderModifyList) > 0">{{getShowWaitConfirm(ordersDetail.orderModifyList)}}</div>
                <div class="upSign upSign3" :style="getShowWaitConfirm(ordersDetail.orderModifyList) > 0 ? {'left': 315+'px'} : {'left': 190+'px'}" v-if="logsNoConfirmed(ordersDetail.otherMatterList) > 0">{{logsNoConfirmed(ordersDetail.otherMatterList)}}</div>

                <Tab-pane v-if="ordersDetail.orderDiaryDescResponseVOList && ordersDetail.orderDiaryDescResponseVOList.length > 0" label="生产资料" name="0">
                  <means
                    :orderDiaryDescResponseVOList="ordersDetail.orderDiaryDescResponseVOList"
                    @exportExcel="exportExcel"
                  ></means>
                </Tab-pane>
                <Tab-pane v-if="ordersDetail.orderModifyList && ordersDetail.orderModifyList.length >0" label="产品修改清单" name="1">
                  <modifys
                    @reloadDetails="getOrdersDetail('upReload')"
                    :lists="orderModifyList" 
                    :allLists="ordersDetail.orderModifyList || []"
                  ></modifys>
                </Tab-pane>
                <Tab-pane v-if="ordersDetail.otherMatterList && ordersDetail.otherMatterList.length > 0" label="订单日志" name="2">
                  <logs
                    :logs="ordersDetail.otherMatterList"
                    @downloadDrawings="downloadDrawings"
                    @logsComfrim="logs_means_comfrim"
                  ></logs>
                </Tab-pane>
              </Tabs>
            </div> 
        </layout>
        </div>

        <!-- 生产资料 -->
        <!-- <layout
          title="生产资料"
          rightBtn="导出面料色板"
          rightBtnMain="查看全部"
          id="meauTarget"
          @rightSubmit="exportExcel"
          @rightMainSubmit="rightMainSubmit"
          v-if="ordersDetail.orderDiaryDescResponseVOList && ordersDetail.orderDiaryDescResponseVOList.length > 0"
        >
          <means
            :orderDiaryDescResponseVOList="ordersDetail.orderDiaryDescResponseVOList"
            @exportExcel="exportExcel"
          ></means>
        </layout> -->

        <!-- 附件 -->
        <layout
          title="附件"
          class="lay-out-m"
          v-if="ordersDetail.attachmentFileList && ordersDetail.attachmentFileList.length > 0"
        >
          <Row
            class="m-t-15"
            :gutter="20"
            type="flex"
            justify="start"
            align="middle"
            v-for="(item, index) in ordersDetail.attachmentFileList"
            :key="index"
          >
            <Col span="4" class="ellipsis">
              <span class="insert">附件{{index+1}}：</span>
              <span>{{item.name}}</span>
            </Col>
            <Col span="3">
              <button
                class="btn-txt"
                :disabled="item.loading"
                @click="attachmentDownload(item)"
              >{{item.loading ? '下载中...' : '下载'}}</button>
            </Col>
          </Row>
        </layout>

        <!-- 生产日志 -->
        <!-- <layout
          title="生产订单日志"
          class="log"
          id="targetLogs"
          v-if="ordersDetail.diarys && ordersDetail.diarys.length > 0"
        >
          <logs
            :logs="ordersDetail.diarys"
            @downloadDrawings="downloadDrawings"
            @logsComfrim="logs_means_comfrim"
          ></logs>
        </layout> -->

        <layout class="layout-invoice" title="发票信息" v-if="ordersDetail.orderInvoice">
          <invoice-detail :details="ordersDetail.orderInvoice"></invoice-detail>
        </layout>
        <div class="products">
          <!-- :projectAdditionalDesc="ordersDetail.projectAdditionalDesc || ''" -->
          <product-item v-if="ordersDetail" :lists="ordersDetail.itemAreaList"></product-item>
        </div>
      </div>
    </div>
    <merge-export ref="mergeExport" @exportPrimaryHandle="exportPrimaryHandle"></merge-export>
    <order-tracking ref="orderTracking"></order-tracking>

    <!-- 合同下载Model -->
    <div class="modelSuccess">
        <Modal
          v-model="downLoadModel"
          title="下载合同"
          width="376"
        >
        <div style="margin-top:-40px;">
          <Row  type="flex" justify="center" align="middle">
              <Col span="17">
                订单合同
              </Col>
              <Col span="7" style="text-aligin:right;">
                <Button @click.native="downDetailHandle(getSignedData ? getSignedData.contractFile : '', getSignedData ? getSignedData.type: '')" type="text">
                  <i class="iconfont icon-download"></i> 
                  {{contractDetailLoading ? '下载中...' : '下载'}}
                </Button>
              </Col>
          </Row>
          <Row  type="flex" justify="center" align="middle">
              <Col span="17">
                订单合同附件
              </Col>
              <Col span="7" style="text-aligin:right;">
                <Button @click.native="exportPrimaryHandle(ordersDetail.confirmedModifyIds)" type="text">
                  <i class="iconfont icon-download"></i> 
                  {{exprotModifyLoading ? '下载中...' : '下载'}}
                </Button>
              </Col>
          </Row>  
        </div> 
          
          <div slot="footer">
            <Button @click="downLoadModelCencel">&nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</Button>
          </div>
        </Modal>
      </div>
  </div>
</template>
 <script>
import { OLD_BASIC_URL } from "@/constants";
import axios from "axios";
import mock from "@/utils/mock";
import layout from "./common/layout";
import priceShow from "./common/price-show";
import logs from "./common/logs";
import productItem from "@/components/product-item";
import means from "./common/means";
import invoiceDetail from "./common/invoice";
import phase from "./common/phase";
import { download } from "@/utils";
import _ from "lodash";
import { permissionFuc } from "@/utils/permissions.js";
import paymentStage from "./common/payment-stage.vue";
import paymentRecord from "./common/payment-record.vue";
import modifys from "./common/modifys.vue";
import mergeExport from '@/components/dialogs/merge-export.vue'
import orderTracking from '@/components/dialogs/order-tracking.vue'
export default {
  name: "OrderDetail",
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      permissionFuc: permissionFuc,
      orderSteps: mock.orderSteps,
      ordersDetail: "",
      getSignedData: "", // 合同信息
      validTime: "", //支付过期时间
      timer: "",
      countdown: "",
      orderModifyList:[],
      exprotModify:false,
      exprotModifyLoading: false,
      rightBtnText: '展开',
      productTodosLab: '0',
      downLoadModel: false,
      allDownLoad: false,
      contractDetailLoading: false
    };
  },
  components: {
    layout,
    priceShow,
    productItem,
    logs,
    means,
    invoiceDetail,
    phase,
    paymentStage,
    paymentRecord,
    modifys,
    mergeExport,
    orderTracking
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get(`/designer_api/stageOrders/stage/${to.params.id}/v3`, {
        globalLoading: true
      })
      .then(res => {
        next(vm => {
          vm.get_signed_contract(to, vm);
          vm.ordersDetail = res;
          if(vm.ordersDetail && vm.ordersDetail.orderModifyList && vm.ordersDetail.orderModifyList.length > 1) {
            vm.orderModifyList.push(vm.ordersDetail.orderModifyList[0]);
          }else if(vm.ordersDetail && vm.ordersDetail.orderModifyList && vm.ordersDetail.orderModifyList.length === 1) {
            vm.orderModifyList = vm.ordersDetail.orderModifyList;
          }

          if(vm.ordersDetail.attachmentFileList && vm.ordersDetail.attachmentFileList.length > 0) {
            vm.ordersDetail.attachmentFileList.forEach(item => {
              vm.$set(item, 'loading', false);
            })
          }

          vm.validTime = res.expirationTime || "";
          vm.orderDiaryNum(vm.ordersDetail.orderDiaryDescResponseVOList);
        });
      });
  },
  computed: {
    /* 右侧主要按钮的文案展示 */
    submit_btn_txt() {
      if (!this.ordersDetail) return false;
      if (this.ordersDetail.deliveryStatus === 1) {
        return { type: 1, txt: "确认收货" };
      }
      if (
        this.ordersDetail.payInfomation &&
        this.ordersDetail.payInfomation.buttonAction === 1 &&
        this.ordersDetail.stateId !== 50
      ) {
        return { type: 2, txt: this.ordersDetail.payInfomation.buttonWord };
      }
      if (this.ordersDetail.payInfomation && this.ordersDetail.stateId === 50) {
        return { type: 3, txt: this.ordersDetail.payInfomation.buttonWord };
      }
      return false;
    },
    /* 其他功能按钮 */
    auxiliary_btn() {
      if (!this.ordersDetail.diarys || !this.ordersDetail.diarys[0])
        return false;
      // if (
      //   this.ordersDetail.diarys[0].status === 4 &&
      //   this.ordersDetail.diarys[0].confirmed === 0
      // ) {
      //   return { type: 4, txt: "修改凭证" };
      // }
      return false;
    },
    BUTTON_NAME() {
      return this.$store.state.BUTTON_NAME;
    },
   
  },
  methods: {
     productTodosLabVal() {
       this.$nextTick(() => {
          // var elements = document.getElementsByClassName('ivu-tabs-ink-bar')[0]
           if(this.ordersDetail.orderDiaryDescResponseVOList && this.orderDiaryNum(this.ordersDetail.orderDiaryDescResponseVOList) > 0) {
        this.productTodosLab = '0';
        //  setTimeout(() => {
        //     elements.setAttribute('style', 'left: 29px;width:30px;opacity:1')
        //   },100)
      }else {
        if(this.ordersDetail.orderModifyList && this.getShowWaitConfirm(this.ordersDetail.orderModifyList) > 0) {
          this.productTodosLab = '1';
          //  setTimeout(() => {
          //   elements.setAttribute('style', 'left: 147px;width:30px;opacity:1')
          // },100)
        }else if(this.ordersDetail.otherMatterList && this.getShowWaitConfirm(this.ordersDetail.otherMatterList) > 0) {
          this.productTodosLab = '2';
          //  setTimeout(() => {
          //   elements.setAttribute('style', 'left: 266px;width:30px;opacity:1')
          // },100)
          
        }else {
          this.productTodosLab = '0';
          //  setTimeout(() => {
          //   elements.setAttribute('style', 'left: 29px;width:30px;opacity:1')
          // },100)
        }
      }
       })
     
    },
    /* 生产资料数量 */
    orderDiaryNum(lists) {
      if(!lists) return 0;
      let totalUnm = 0;
      lists.forEach((item) => {
        if(item.unconfirmedNum && item.unconfirmedNum > 0) {
          totalUnm = totalUnm + item.unconfirmedNum;
        }
      })
      return totalUnm;
    },
    /**
     * 是否需要显示确认修改单
     */
    getShowWaitConfirm(lists) {
      if (!lists || lists.length === 0) return 0;
      let query = null;
      query = lists.filter(item => item.confirmed === 0);
      if (query && query.length > 0) {
        return query.length;
      } else {
        return 0;
      }
    },

    /* 确定日志没有确认的数量 */
    logsNoConfirmed(lists) {
      if(!lists) return 0;
      let totalUnm = 0;
      lists.forEach((item) => {            
        if(item.confirmed == 0) {
          totalUnm = totalUnm + 1;    
        }
      })
      return totalUnm;
    },

    onTabChange(value) {
      this.productTodosLab = value;
      // this.$nextTick(() => {
      //   var elements = document.getElementsByClassName('ivu-tabs-ink-bar')[0]
      //   if(value == 0) {
      //     setTimeout(() => {
      //       elements.setAttribute('style', 'left: 29px;width:30px;opacity:1')
      //     },100)
          
      //   }
      //   if(value == 1) {
      //     setTimeout(() => {
      //       elements.setAttribute('style', 'left: 147px;width:30px;opacity:1')
      //     },100)
          
      //   }
      //   if(value == 2) {
      //     setTimeout(() => {
      //       elements.setAttribute('style', 'left: 266px;width:30px;opacity:1')
      //     },100)
          
      //   }
      // })
       
    },
    /* 合并导出 */
    exportDataHandle() {
      this.$refs.mergeExport.open(this.ordersDetail && this.ordersDetail.orderModifyList)
    },
    /* 合并导出修改单 */
    exportPrimaryHandle(listIds) {
      this.exprotModify = true;
      this.exprotModifyLoading = true;
      let obj = {
        modifyIds: listIds,
        orderId: this.$route.params.id
      }
      axios.post(`/designer_api/order_modify/excel`,obj).then(res => {
        download(this.ossPrefix + res);
        this.$Message.success('导出成功');
        this.exprotModify = false;
        this.exprotModifyLoading = false;
      }).catch(() => {
         this.exprotModify = false;
         this.exprotModifyLoading = false;
      })
    },
    /* 产品修改清单的展开和收起 */
    toggleHandle(toggle) {
      this.orderModifyList = [];
      if(!toggle && this.ordersDetail.orderModifyList && this.ordersDetail.orderModifyList.length > 0) {
        this.orderModifyList.push(this.ordersDetail.orderModifyList[0])
      }else if(toggle && this.ordersDetail.orderModifyList && this.ordersDetail.orderModifyList.length > 0) {
        this.orderModifyList = this.ordersDetail.orderModifyList;
      }
    },
     /* 查看资料全部 */
    rightMainSubmit() {
      window.location.href =
        this.VUE_APP_OLD_BASIC_URL +
        "/my/order/production/" +
        this.$route.params.id;
    },
    getOrdersDetail(upReload = null) {
      axios
        .get(`/designer_api/stageOrders/stage/${this.$route.params.id}/v3`, {
          globalLoading: true
        })
        .then(res => {
          this.get_signed_contract();
          this.ordersDetail = res;
          
          this.orderModifyList = [];
          if(!upReload) {
            if(this.ordersDetail && this.ordersDetail.orderModifyList && this.ordersDetail.orderModifyList.length > 1) {
              this.orderModifyList.push(this.ordersDetail.orderModifyList[0]);
            }else if(this.ordersDetail && this.ordersDetail.orderModifyList && this.ordersDetail.orderModifyList.length === 1) {
                this.orderModifyList = this.ordersDetail.orderModifyList;
            }
            this.$emit('global:rightBtnTextHandle');
          }else {
            this.orderModifyList = this.ordersDetail.orderModifyList;
            this.productTodosLab = '1';
          }

          if(this.ordersDetail.attachmentFileList && this.ordersDetail.attachmentFileList.length > 0) {
            this.ordersDetail.attachmentFileList.forEach(item => {
              this.$set(item, 'loading', false);
            })
          }
        
          this.validTime = this.expirationTime;
          this.createTimer();
          this.logsNoConfirmed(this.ordersDetail.otherMatterList)
          this.getShowWaitConfirm(this.orderModifyList)
          this.orderDiaryNum(this.ordersDetail.orderDiaryDescResponseVOList);
         
        });
    },

    /* 合同信息展示接口 */
    get_signed_contract(to = null, vm = null) {
      let id;
      id = to ? to.params.id : this.$route.params.id;
      axios
        .get(`/designer_api/bestSign/signed_contract?orderId=${id}`)
        .then(re => {
          if (vm) {
            vm.getSignedData = re;
          } else {
            this.getSignedData = re;
          }
        });
    },


    /* 主要按钮提交 */
    submitBtnHandle(type) {
      switch (type) {
        case 1 /* 确认收货 */:
          this.confirm_goods();
          break;
        case 2 /* 付款 */:
          this.toPayOrder();
          break;
        case 3 /* 确认合同 */:
          this.contractSure();
          break;
        default:
          this.contractSure();
      }
    },

    /* 确认合同 */
    contractSure() {
      if (!this.permissionFuc("order:contract", "click")) return false;
      // 跳转确认合同页面
      this.$router.push({
        name: "Contract",
        params: { id: this.$route.params.id },
        query: {
          txt:
            this.ordersDetail.contractPartyB ===
            "斑斓供应链管理（上海）有限公司"
              ? 1
              : 2
        }
      });
    },

    /* 付款 */
    toPayOrder() {
      if (!this.permissionFuc("order:pay", "click")) return false;
      if(this.ordersDetail.payInfomation && this.ordersDetail.payInfomation.amountDisplay==0) { // 调用付款是0的情况
        this.payButtonLoading = true;
        axios.post(`/designer_api/stageOrders/payment_zero`, this.ordersDetail.payInfomation).then(res => {
            this.getOrdersDetail();
            this.$Message.success('支付成功！');
            this.payButtonLoading = false;
        })
      }else {  // 正常的付款阶段
        let type = 1;
        location.href = `${OLD_BASIC_URL}/my/pay/choicePay/${this.$route.params.id}/1`;
      }
      
    },

    /* 取消订单 */
    cencelOrderHandle() {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要取消此订单吗？</p>",
        onOk: () => {
          this.cencelOrders();
        }
      });
    },

    cencelOrders() {
      axios
        .put(`/designer_api/stageOrders/cancel/${this.$route.params.id}`)
        .then(res => {
          this.ordersDetail.stateId = 600;
          this.$Message.success("取消成功");
        });
    },

    /* 确认收货 */
    confirm_goods() {
      this.$Modal.confirm({
        title: "提示",
        loading: true,
        content: "<p>确认您已收到商品？</p>",
        onOk: () => {
          this.confirm_goods_handle()
            .then(res => {
              this.$Message.success("确认收货成功");
              this.$router.go(0);
            })
            .catch(err => {
              this.$Modal.remove();
            });
        }
      });
    },
    
    confirm_goods_handle() {
      return new Promise((resovle, reject) => {
        axios
          .put(`/designer_api/stageOrders/confirm/${this.$route.params.id}`)
          .then(res => {
            this.$Modal.remove();
            resovle(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /*  
      图纸/面料/色板 的下载
    */
    downloadDrawings(files) {
      let id = (files.colorOrMaterial && files.colorOrMaterial.id) || files.id;
      axios
        .get(`/designer_api/files/download/v3?fileId=${id}&needDeduct=1`, {
          btn_loading: "ORDER_DOWN_LOAD"
        })
        .then(res => {
          this.$Message.success("下载成功");
          download(this.ossPrefix + res);
        });
    },

    /* 导出面料色板EXCEL */
    exportExcel() {
      axios
        .get(
          `/designer_api/stageOrders/${this.ordersDetail.id}/prduct_material_zip`,
          {
            btn_loading: "EXPORT_MEANS"
          }
        )
        .then(res => {
          this.$Message.success("导出成功");
          download(this.ossPrefix + res);
        });
    },

    /* 附件下载 */
    attachmentDownload(files) {
      this.$set(files, 'loading', true);
      axios
        .get(
          `/designer_api/files/download/v3?fileId=${files.id}&needDeduct=1`,
          { btn_loading: "ORDER_DOWN_LOAD" }
        )
        .then(res => {
          this.$Message.success("下载成功");
          download(this.ossPrefix + res);
          this.$set(files, 'loading', false)
        });
    },

    downLoadModelCencel() {
      this.downLoadModel = false;
    },

    /* 合同下载 / 合同预览 */
    contractDownLoad(files, type) {
      if(!files && type === 1) {
        /* 跳转合同确认页 */
        this.contractSure();
        return false;
      }
      if(this.ordersDetail.confirmedModifyIds && this.ordersDetail.confirmedModifyIds.length > 0) {
          this.downLoadModel = true;
      }else {
        this.downDetailHandle(files, type);
      }
    },

    downDetailHandle(files, type) {
      if(!files) {
        this.$Message.error("暂时无法下载");
        return;
      }else {
        this.contractDetailLoading = true;
        axios
          .get(
            `/designer_api/files/download/v3?fileId=${files.id}&needDeduct=1`,
            { btn_loading: "ORDER_DOWN_LOAD" }
          )
          .then(res => {
            this.$Message.success("下载成功");
            this.contractDetailLoading = false;
            download(this.ossPrefix + res);
          }).catch(err => {
            this.contractDetailLoading = false;
          });
      }
      
    },

    /* 总状态显示 */
    totalStatus(detailStatus) {
      if(!detailStatus) return null;
      switch(detailStatus) {
        case 50: // 订单待确认合同
          return {
            icon: 'icon-daiqueren',
            btn_main: '确认合同',
            btn_sub: '下载合同',
            status: 0,
            text_btn: [
              {
                title: '订单跟踪',
                status: 0
              },
              {
                title: '取消订单',
                status: 1
              },
            ]
          }
          break;
        case 100:
            return {
            icon: 'icon-card',
            btn_main: '付款',
            btn_sub: '订单跟踪',
            status: 1,
            text_btn: [
              {
                title: '下载合同',
                status: 2
              },
              {
                title: '取消订单',
                status: 3
              },
            ]
          }
          break;
        case 200:
            return {
              icon: 'icon-daiquerendaishangchuan',
              btn_main: '付款',
              btn_sub: '',
              status: 2,
              text_btn: [
                {
                  title: '订单跟踪',
                  status: 0
                },
                {
                  title: '下载合同',
                  status: 2
                },
              ]
          }  
        case 300:
        case 950:
        case 500:
        case 700:
        case 900:
            return {
              icon: 'icon-daiquerendaishangchuan',
              btn_main: '付款',
              btn_sub: '确认事项',
              status: 2,
              text_btn: [
                {
                  title: '订单跟踪',
                  status: 0
                },
                {
                  title: '下载合同',
                  status: 2
                },
              ]
          }
          break;
          case 800:
            return {
              icon: 'icon-daiquerendaishangchuan',
              btn_main: '确认收货',
              btn_sub: '确认事项',
              status: 5,
              text_btn: [
                {
                  title: '订单跟踪',
                  status: 0
                },
                {
                  title: '下载合同',
                  status: 2
                },
              ]
          }
          break;
          case 400:
            return {
            icon: 'icon-Success',
            btn_main: '付款',
            btn_sub: '申请售后',
            status: 3,
            text_btn: [
              {
                title: '订单跟踪',
                status: 0
              },
              {
                title: '下载合同',
                status: 2
              },
            ]
          }
          break;
        case 600:
            return {
            icon: 'icon-close-circle',
            btn_sub: '删除订单',
            status: 4,
            text_btn: null
          }
          break;
      }
    },

    /* 主要红色按钮 */
    totalMainActionHandle(status) {
      switch(status) {
        case 0: // 确认合同
          this.contractSure();
          break;
        case 1:
        case 2:
        case 3: // 付款
          this.toPayOrder();
          break;
        case 5:
          this.confirm_goods();
          break;
      }
    },

    // 主要次级按钮
    totalSubActionHandle(status) {
      switch(status) {
        case 0: // 下载合同
          this.downlAction();
          break
        case 1: // 查看日志
          // var dom = document.getElementById('#setOffProduct');
          // document.documentElement.scrollTop = dom.offsetTop;
          // this.productTodosLab = '2';
          if(this.ordersDetail.orderTrackList && this.ordersDetail.orderTrackList.length > 0) {
            this.$refs.orderTracking.open(this.ordersDetail.orderTrackList);
          }else {
            this.$Message.warning('暂无订单跟踪记录');
          }
          break 
        case 2:
        case 5: // 生产资料
          // this.productTodosLab = '0';
          var dom = document.getElementById('#setOffProduct');
          document.documentElement.scrollTop = dom.offsetTop;
          break; 
        case 3: // 申请售后
          this.$nextTick(() => {
            this.$emit("global:sendUdesk");
          });
          break;
        case 4: // 删除订单
          this.deleteHandle();
          break;       
      }
    },
    // 按钮组
    totalActionsHandle(status) {
      switch(status) {
        case 0: // 查看日志--订单跟踪
          // this.productTodosLab = '2';
          // var dom = document.getElementById('#setOffProduct');
          // document.documentElement.scrollTop = dom.offsetTop;
          if(this.ordersDetail.orderTrackList && this.ordersDetail.orderTrackList.length > 0) {
            this.$refs.orderTracking.open(this.ordersDetail.orderTrackList);
          }else {
            this.$Message.warning('暂无订单跟踪记录');
          }
          break
        case 1: // 取消订单
          this.cencelOrderHandle();
          break
        case 2: // 下载合同
          this.downlAction();
          break   
        case 3: // 取消订单
          this.cencelOrderHandle();
          break
        case 4: // 生产资料
          this.productTodosLab = '0';
          var dom = document.getElementById('#setOffProduct');
          document.documentElement.scrollTop = dom.offsetTop;
          break     
      }
    },

    /* 删除订单 */
    deleteHandle() {
      e.stopPropagation();
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除订单吗？</p>",
        onOk: () => {
          axios.delete(`/designer_api/stageOrders/${this.$route.params.id}`).then(() => {
            this.$router.go(-1);
          });
        }
      });
    },

    /* 下载合同 action */
    downlAction() {
      if(this.permissionFuc('order:contract:download')) {
        if(this.ordersDetail.confirmedModifyIds && this.ordersDetail.confirmedModifyIds.length > 0) {
          this.downLoadModel = true;
        }else {
          if(this.getSignedData && this.getSignedData.contractFile) {
            window.open(this.ossPrefix + this.getSignedData.contractFile.key);
          }else {
            this.$Message.error('暂时无法下载')
          }
        }
      }else {
        this.$Message.error('没有下载权限')
      }
      
    },

    /* 图纸、面料、色板、普通日志的确认 */
    logs_means_comfrim(item, target) {
      let text;
      switch (target) {
        case -1:
          text = "是否确认该日志内容？";
          break;
        case 0:
          text = "确定让当前色板进入生产？";
          break;
        case 1:
          text = "确定让当前图纸进入生产？";
          break;
        case 5:
          text = "确定让当前图纸进入生产？";
          break;
        case 2:
          text = "确定让当前面料进入生产？";
          break;
        case 6:
          text = "确定让所有色板进入生产？";
          break;
        case 7:
          text = "确定让所有面料进入生产？";
          break;
        default:
          text = "是否确认该日志内容？";
      }
      this.$Modal.confirm({
        title: "提示",
        loading: true,
        content: text,
        onOk: () => {
          this.logs_means_comfrim_handle(item, target)
            .then(promise => {
              this.$Message.success("确认提交成功！");
              this.getOrdersDetail();
              this.productTodosLab = '2'
            })
            .catch(err => {
              this.$Modal.remove();
              this.productTodosLab = '2'
            });
        }
      });
    },
    logs_means_comfrim_handle(item, target) {
      return new Promise((resovle, reject) => {
        if (target === 6 || target === 7) {
          this.material_confirmed(item, target)
            .then(res => {
              resovle(res);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          this.color_drawing_confirm_v2(item, target)
            .then(res => {
              resovle(res);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    color_drawing_confirm_v2(item, target) {
      let id;
      id = target == 5 ? item.diaryId : item.id;
      return new Promise((resovle, reject) => {
        axios
          // .post(`/designer_api/diarys/color_drawing_confirm/${id}/v2`)
          .post(`/designer_api/diarys/${id}/confirm/v3`)
          .then(res => {
            this.$Modal.remove();
            resovle(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /* 面料色板确认 */
    material_confirmed(item, target) {
      return new Promise((resovle, reject) => {
        axios
          .post(
            `/designer_api/diarys/${this.$route.params.id}/material_confirmed?type=${target}`
          )
          .then(res => {
            this.$Modal.remove();
            resovle(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /* 遍历进行的当前阶段 */
    guideListActive(lists) {
      if (!lists || lists.length === 0) return false;
      let _index = 0,
        statusLists = [];
      lists.forEach((element, index) => {
        if (element.status === 300) {
          statusLists.push(element.status);
        }
        if (element.status === 200) {
          _index = index;
        } else if (statusLists.length === lists.length) {
          _index = lists.length;
        }
      });
      return _index;
    },

    /* 从付款阶段 emit  */
    submitBtnHandleStage(type, file = null) {
      if (type === "download") {
        /* 合同下载 */
        this.contractDownLoad(file);
      } else {
        this.submitBtnHandle(type);
      }
    },

    /* 付款倒计时 */
    showtime() {
      if(!this.validTime) {
        this.countdown = '';
        return false
      }
      var endtime = this.validTime;
      var nowtime = new Date();
      var lefttime = parseInt((endtime - nowtime) / 1000);
      var d = parseInt(lefttime / (24 * 60 * 60));
      var h = parseInt((lefttime / (60 * 60)) % 24);
      var m = parseInt((lefttime / 60) % 60);
      var s = parseInt(lefttime % 60);
      h = this.addZero(h);
      m = this.addZero(m);
      s = this.addZero(s);
      this.countdown = '剩余付款时间：' + `${d}` + `天` + h + "时" + m + "分" + s + '秒';
      if (lefttime <= 0) {
        this.countdown = '';
        clearInterval(this.timer);
      }
    },

    addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    createTimer() {
      this.timer = setInterval(() => {
        this.showtime()
      }, 1000)
    },

    /* 得到target 来显示 tab */
    setOffProduct() {
      let target = this.$route.query.target;
      this.$nextTick(() => {
        if(target && this.ordersDetail){
          var dom = document.getElementById('#setOffProduct');
          document.documentElement.scrollTop = dom.offsetTop;
          this.productTodosLab = target;
          // if(document.body.scrollTop) {
          //   document.body.scrollTop  = dom.offsetTop;
          // }else if(document.documentElement.scrollTop) {
          //   document.documentElement.scrollTop = dom.offsetTop;
          // }else if(window.pageYOffset) {
          //   window.pageYOffset = dom.offsetTop;
          // }
        }
      })
    },

    setTabHancle() {
        if(this.ordersDetail) {
          this.$nextTick(() => {
            var elements = document.getElementsByClassName('ivu-tabs-ink-bar')[0]
          
            if(elements) {
              elements.setAttribute('style', 'left: 29px;width:30px;opacity:1')
            }
        })
      } 
    }
  },
  created() {
    /* 权限 */
    this.$store.dispatch("permission", { orderId: this.$route.params.id });
  },
  watch: {
    validTime: function() {
      this.createTimer();
    },
    $route(to, from) {
      this.getOrdersDetail();
      this.orderDiaryNum(this.ordersDetail.orderDiaryDescResponseVOList);
      
    },
    ordersDetail: function() {
      this.setOffProduct();
      // this.setTabHancle()
      this.productTodosLabVal()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
 <style lang="scss">
 .orders {
   .orders-com {
     position: relative;
     .cancel-dialog {
       position: absolute;
       width: 100%;
       height:100%;
       z-index: 500;
       top:0;
       left:0px;
       background: #f3f3f3;
       opacity: 0.5;
     }
   }
 }
.order-detail {
  .action-all {
    width: 100%;
    height: 100%;
    background: url('../../assets/order-detail-bg.png');
    background-repeat: no-repeat;
        background-size: 100% 100%;
    padding: 20px 30px;
    .stateText {
      i {
        font-size: 18px;
        color:#fff;
        font-weight: 500;
        vertical-align: middle;
      }
      span {
        font-weight: 500;
        font-size: 16px;
        color:#fff;
        vertical-align: middle;
        display: inline-block;
        margin-left: 5px;
      }
    }
    .subStateText {
      font-size: 14px;
      color: #E7E7E7;
      margin-top: 5px;
    }
    .stateBtn {
      margin-top: 30px;
      .ivu-col {
        font-size: 14px;
        color: #F1F1F1;
        >span {
          font-size: 14px;
          color:#fff;
          text-decoration: underline;
          cursor: pointer;
          display: inline-block;
          vertical-align: middle;
          margin-right: 13px;
          &:hover {
            color:#EB5757;
          }
        }
      }
    }
  }
  .order-title {
    color: #21201f;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    i {
      cursor: pointer;
    }
  }
  .order-info {
    margin-bottom: 40px;
    p {
      margin-bottom: 12px;
      span {
        font-weight: 400;
      }
      span.price {
        color: #e14b5d;
      }
      span.first-scond {
        margin-left: 30px;
      }
      .download {
        margin-left: 43px;
      }
      .Tag {
        margin-left: 10px;
        cursor: default;
      }
      .Tag-big {
        height: 26px;
        width: 60px;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .log {
    .time {
      font-weight: 500;
      color: #21201f;
    }
  }
  .main_btn {
    margin-top: 30px;
  }
  .lay-out-m {
    .main {
      padding-top: 15px;
    }
  }
  .layout-invoice {
    .main {
      padding-top: 1px;
    }
  }
  .closeOrder {
    height: 80px;
    background: #fff;
    // line-height: 80px;
    padding-left: 30px;
    position: relative;
    z-index: 600;
    span {
      color: #e56a69;
      font-size: 18px;
      font-weight: 500;
      display: inline-block;
      margin-top:16px;
    }
  }
  .products {
    padding-bottom: 20px;
    background: #fff;
  }

  .product-todos {
    padding: 0px;
    margin-top: -10px;
    position: relative;
    .detail-tab-style {
      position: relative;
      .ivu-tabs-bar {
        border: none;
        margin-bottom: 30px;
      }
      .upSign {
        display: inline-block;
        position: absolute;
        z-index: 10;
        color: #EB5757;
        top: 2px;
        font-size: 12px;
        background: #EB5757;
        height: 17px;
        border-radius: 50%;
        width: 17px;
        color: #fff;
        line-height:17px;
        text-align: center;
      }
      .upSign1 {
        left: 80px;
      }
      .upSign2 {
        left: 210px;
      }
      .upSign3 {
        left: 315px;
      }
    }
    .product-laylot {
      position: absolute;
      z-index: 10;
      top: 0px;
      right: 0px;
      width: 500px;
      margin-top: 0px;
      .title {
        border:none;
        &>span{
          display: none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.detail-tab-style {
  .ivu-tabs-ink-bar {
    // width: 30px !important;
    background-color: #ec6464 !important;
    // opacity: 0;
    // left: 29px;
  }
  .ivu-tabs-nav .ivu-tabs-tab-active {
    font-weight: 500 !important;
  }
}
</style> 
 
 
 